import { GroupHighlightSlidesLoadingSkeleton } from "pages/[tenant]/browse/components/Carousel/components/GroupHighlight/GroupHighlightSlidesLoadingSkeleton";

import { LoadingSkeleton } from "shared/components/molecules/LoadingSkeleton";

import { GroupHighlightSectionLoadingSkeletonContainer } from "./styles";

interface IGroupHighlightSectionLoadingSkeletonProps {
  contentLength: number;
}

export const GroupHighlightSectionLoadingSkeleton = ({
  contentLength,
}: IGroupHighlightSectionLoadingSkeletonProps) => {
  return (
    <GroupHighlightSectionLoadingSkeletonContainer>
      <div className="texts">
        <LoadingSkeleton.Text width="200px" />

        <div>
          <LoadingSkeleton.Text width="100%" />
          <LoadingSkeleton.Text width="80%" />
        </div>
      </div>

      <GroupHighlightSlidesLoadingSkeleton
        contentLength={contentLength}
        orientation="horizontal"
      />
    </GroupHighlightSectionLoadingSkeletonContainer>
  );
};
